import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from 'src/app/models/user.model';
import { getLocalTranslate } from 'src/app/helpers/global-functions'
import { UploadService } from 'src/app/services/upload.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css']
})


export class MyAccountComponent implements OnInit {

  user: User;

  showSpinner: boolean = false

  logout: string = 'Logout'
  home: string = 'Home'
  myAccount: string = 'My Account'
  addImage: string = 'Add Photo'
  removeImage: string = 'Remove Photo'
  hasImage:boolean = false

  photoUrl:string = ''

  items: MyAccountItem[] = []
  constructor(
    private authService: AuthService,
    private uploadService:UploadService,
    private router: Router,
    private activedRoute: ActivatedRoute,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {

    const cond = (this.authService.avatarUrl !=null) && (this.authService.avatarUrl != ''); 
    console.log("Cond"+cond);
    this.hasImage = cond;
    this.photoUrl = cond ? this.authService.avatarUrl : 'assets/img/avatar.png';
    this.needTranslate()
    let user = JSON.parse(localStorage.getItem('user'));
    this.user = {
      email: user.email,
      displayName: user.displayName
    };

    this.prepareItems()
  }



  needTranslate() {
    this.logout = getLocalTranslate('logout', this.logout)
    this.home = getLocalTranslate('home', this.home)
    this.myAccount = getLocalTranslate('my-account', this.myAccount)
    this.addImage = getLocalTranslate('add-photo', this.myAccount)
    this.removeImage = getLocalTranslate('remove-phtoo', this.removeImage)
  }

  onLogout() {
    this.authService.onLogout();
  }

  prepareItems() {
    const userType = localStorage.getItem('user-type')
    if (userType === '1') {
      // Student
      this.items = [
        {
          title: 'My Courses',
          moduleName: 'courses',
          iconClassName: 'bx-list-check'
        },
        {
          title: 'Dashboard',
          moduleName: 'dashboard',
          iconClassName: 'bxs-dashboard'
        },
      ]
      let splitUrls = this.router.url.split('/');
      var lastUrl: string = '';
      if (splitUrls.length > 0) {
        lastUrl = splitUrls[splitUrls.length - 1];
      }
      this.items = this.items.map(function (item) {
        if (item.moduleName === 'courses') {
          item.title = getLocalTranslate('my-courses', item.title)
        } else {
          item.title = getLocalTranslate('dashboard', item.title)
        }
        var newItem = { ...item };
        newItem.isActive = (item.moduleName === lastUrl);
        return newItem
      });
    } else if (userType === '2') {
      // Teacher
      this.items = [
        {
          title: 'Comments',
          moduleName: 'teacher-comments',
          iconClassName: 'bxs-message',
          isActive: true
        },
        {
          title: 'Courses',
          moduleName: 'courses',
          iconClassName: 'bx-list-ul'
        },
      ]
      let splitUrls = this.router.url.split('/');
      var lastUrl: string = '';
      if (splitUrls.length > 0) {
        lastUrl = splitUrls[splitUrls.length - 1];
      }
      this.items = this.items.map(function (item) {
        if (item.moduleName === 'teacher-comments') {
          item.title = getLocalTranslate('Comments', item.title)
        } else {
          item.title = getLocalTranslate('Courses', item.title)
        }
        var newItem = { ...item };
        newItem.isActive = (item.moduleName === lastUrl);
        return newItem
      });
    }


  }

  async onItemClicked(item: MyAccountItem) {
    let basePath = this.activedRoute.parent.routeConfig.path.concat("/" + this.activedRoute.routeConfig.path);
    let path = basePath.concat("/" + item.moduleName);
    await this.router.navigate([path]);
    this.prepareItems();
  }

  onRemoveImage(){
    const result = confirm("Are you sure to remove this photo?");
    if (!result) {
      return;
    }
    const path = this.authService.avatarUrl;

    this.showSpinner = true;

    this.uploadService.delete(path).then(_=>{
      this.authService.updateAvatarUrl("");
      this.toastr.success("Removed image Successfully");
      setTimeout(() => {
        window.location.reload();
      }, 1000)
      this.showSpinner = false;
    });



  }

  onAddImage(){
      this.router.navigate(['update-photo']);
  }

}

interface MyAccountItem {
  title: string
  moduleName: string
  isActive?: boolean
  iconClassName: string
}
